// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".history-table[data-v-6dcb4405]{height:470px}.history-table[data-v-6dcb4405] .v-table__wrapper th,.history-table[data-v-6dcb4405] .v-table__wrapper td{overflow:hidden;white-space:nowrap !important;text-overflow:ellipsis !important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
